<template>
  <div class="content">
    <el-empty :image="img" :image-size="223" description="您的服务已到期，请联系管理员">
      <div style="font-size: 14px;color: #909399;margin-bottom:20px">客服电话：029-85799709</div>
      <el-button type="primary" size="mini" @click="renewal">立即续费</el-button>
    </el-empty>
  </div>
</template>
<script>
// import Vue from 'vue'
import openLink from 'dingtalk-jsapi/api/biz/util/openLink' // 跳转至服务群
// import { saveFeedBack } from '../utils/api/more'
var img = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/stateImg/dueto_pc.png'
import Store from '@/store/index'
import Vue from 'vue'
export default {
  data() {
    return {
      img: img,
      channel: this.$route.query.channel
    }
  },
  mounted() {
    Store.commit('user/setLoading', false)
  },
  methods: {
    renewal() {
      // var goodsCode = 'DT_GOODS_881660535324709'
      // var corpId = this.$route.query.corpId
      // var token = '6aef39bcdb6887181d717e5b17c9836b'
      // openLink({
      //   url: `https://page.dingtalk.com/wow/dingtalk/act/serviceconversation?ddtab=true&wh_biz=tm&showmenu=false&goodsCode=${goodsCode}&corpId=${corpId}&token=${token}`
      // })
      if (this.channel === 'ding') {
        var goodsCode = 'DT_GOODS_881660535324709'
        var corpId = this.$route.query.corpId
        var token = '6aef39bcdb6887181d717e5b17c9836b'
        openLink({
          url: `https://page.dingtalk.com/wow/dingtalk/act/serviceconversation?ddtab=true&wh_biz=tm&showmenu=false&goodsCode=${goodsCode}&corpId=${corpId}&token=${token}`
        })
      } else if (this.channel === 'wechat') {
        Vue.prototype.$wx.invoke('openThirdAppServiceChat', {
          success: function(res) {
            // 回调
          }
        })
      } else {
        window.location.href = 'https://applink.feishu.cn/T8ZhbxaPSUJX'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/index.scss';
.content{
  width: 100%;
  height: 100%;
  background: $color_white;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button--mini {
  padding: 2px 14px;
  border-radius: 4px;
}
</style>
